// @flow

import React from 'react';

type Props = {
  service: Object,
};

export default function DaySummaryServices({ services }: Props) {
  let newServices = [];

  services &&
    services.map(service => {
      if (service === 'breakfast') {
        newServices.push({ name: service, is_included: true });
        newServices.push({ name: 'lunch', is_included: false });
      } else {
        newServices.push({ name: service, is_included: true });
      }

      return null;
    });

  return newServices.map((service, i) => (
    <li
      key={`${service}${i}`}
      className={service.is_included ? 'included' : 'not-included'}
    >
      {service.name}
    </li>
  ));
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DaySummary/DaySummaryServices.js